import { useAuthToken, useDeepLinker } from '#src/hooks';

export function useAutoLoginDeepLink(attrs = {}) {
  const { authToken, error: authTokenError } = useAuthToken();
  const deepLinkerAttrs = authToken && { authToken, ...attrs };
  // Init deep linker only after authToken is available
  const { deepLinkUrl, error, handleClick } = useDeepLinker(deepLinkerAttrs);

  return {
    deepLinkUrl,
    error: error || authTokenError,
    handleClick,
  };
}
